import api from '../../api';
import { getSubscriptionInfoAction } from './subscription';

export const SET_PROFILE_LOADING = 'SET_PROFILE_LOADING';
export const SET_PROFILE = 'SET_PROFILE';
export const LOG_OUT = 'LOG_OUT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const setProfileLoading = (loading) => ({
	type: SET_PROFILE_LOADING,
	payload: loading,
});

export const setProfile = (profile) => ({
	type: SET_PROFILE,
	payload: profile,
});

export const logoutAction = () => ({
	type: LOG_OUT,
});

export function getProfileAction() {
	return async function getUserProfile(dispatch) {
		const { token } = localStorage;
		if (!token) dispatch(logoutAction());
		try {
			dispatch(setProfileLoading(true));
			const { data } = await api.getUserProfile();
			if (data.status === 'ok') {
				dispatch(setProfile(data?.user));
				dispatch(getSubscriptionInfoAction());
			} else {
				dispatch(logoutAction());
			}
		} catch (error) {
			console.error({ error });
			dispatch(logoutAction());
		} finally {
			dispatch(setProfileLoading(false));
		}
	};
}
